import { render, staticRenderFns } from "./UserAddNotification.vue?vue&type=template&id=080ed84b&"
import script from "./UserAddNotification.vue?vue&type=script&lang=js&"
export * from "./UserAddNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserAddNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports